import React from 'react'

function BlockChainServiceDetails() {
    return (
        <div>
            <div className="services-details-area default-padding">
                <div className="cotnainer">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="site-heading text-center">
                                <h4 className="sub-title">Performance Marketing</h4>
                                <h2 className="title">Smart PPC Campaigns for Smarter Business Growth</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="services-details-items">
                        <div className="row">
                            <div className="col-xl-12 services-single-content">
                                <div className="thumb mb-50">
                                    <img src="static/img/blockchain/21.jpg" alt="Thumb" />
                                </div>
                                <p>
                                    Microcode Software has been implementing high-value ads via pay-per-click (PPC) advertising for various business purposes for a number of years. If you want your ads to not only present you with results but also target the right people at the right time, we can help with our advertising that emphasizes results! There is no shortage of marketing for this entire industry, we want to help you get measurable data for your business and maximize your ROI.
                                    With our premium PPC management, every click is contributing to your growth.
                                </p>
                                <div className="process-style-one-items mt-50">
                                    <div className="choose-us-one-thumb">
                                        <div className="content">
                                            <div className="left-info">
                                                <h2 className="title">
                                                    Clicks That Count, Results That Scale
                                                </h2>
                                            </div>
                                            <div className="process-style-one">
                                                <div className="process-style-one-item">
                                                    <span>01</span>
                                                    <h4>Planning & Strategy</h4>
                                                    <p>
                                                        Define your goals, audience, keywords, and budget before launching your PPC campaign.
                                                    </p>
                                                </div>
                                                <div className="process-style-one-item">
                                                    <span>02</span>
                                                    <h4>Campaign Setup</h4>
                                                    <p>
                                                        Create ad groups, write compelling ads, and link them to optimized landing pages.
                                                    </p>
                                                </div>
                                                <div className="process-style-one-item">
                                                    <span>03</span>
                                                    <h4>Monitoring & Optimization</h4>
                                                    <p>
                                                        Track results, test variations, and adjust bids and keywords to improve performance.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default BlockChainServiceDetails
